import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'fb-product-sku',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './product-sku.component.html',
	styleUrls: ['./product-sku.component.scss']
})
export class ProductSkuComponent {

	@Input() public label: string = 'SKU';
	@Input() public value: string = '';

	public copied = false;

	public copyToClipboard(): void {
		navigator.clipboard.writeText(this.value).then(() => {
			this.copied = true;
			setTimeout(() => (this.copied = false), 1500);
		});
	}
}
